import { Authenticator } from "@aws-amplify/ui-react"
import { Outlet, useNavigate } from "react-router-dom"
import { useCallback, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { apiFetchExercises, apiFetchResults } from "./api/api"
import { enableApi, forgetExercises, setItems } from "./store/exercisesSlice"
import { forgetResults, setResults } from "./store/resultsSlice"
import { useEffect } from "react"
import { Grid, View } from "@aws-amplify/ui-react"
import { Link } from "react-router-dom"
import { AuthAppNavBar } from "./pages/components/auth-app-nav-bar"
import { useRef } from "react"
import { forgetPosts } from "./store/postsSlice"
import { forgetComments } from "./store/commentsSlice"
import { useAuthenticator } from "@aws-amplify/ui-react"

export const AuthLayout = ({ searchText, onSearchTextChanged, language, onLanguageChanged }) => {

    const [exercisesLoading, setExercisesLoading] = useState(false)
    const navigate = useNavigate()
    const safeSignOut = useRef(null)
    const exercises = useSelector((state) => {
        return state?.exercises?.items
    })
    const apiEnabled = useSelector((state) => state.exercises?.apiEnabled)

    const dispatch = useDispatch()

    const { user } = useAuthenticator((context) => [context.user]);

    const fetchExercises = useCallback(async (_user) => {
        setExercisesLoading(true)
        try {
            const response = await apiFetchExercises(_user)
            const items = response.data?.filter((e) => e.deleted === false)
            dispatch(setItems(items))
            //console.log('If there were no exercises, 100% there were no results for favorites!')
            const favoriteExercises = items?.filter((value, index) => value.favorite === true)
            for await (const exercise of favoriteExercises) {
                const resultsResponse = await apiFetchResults(_user, exercise.id)
                dispatch(setResults({
                    items: resultsResponse?.data,
                    id: exercise.id
                }))
            }

        } catch (e) {
            console.log('Fetching exercises failed')
            console.log(e)
        } finally {
            setExercisesLoading(false)
        }
    }, [dispatch])

    useEffect(() => {
        if (!exercises && apiEnabled) {
            if (user) {
                //console.log('Exercises not cached, loading from server')
                fetchExercises(user.userId)
            }
        }
    }, [exercises, apiEnabled, user, fetchExercises]);

    useEffect(() => {
        if (user) {
            dispatch(enableApi())
            //console.log('api enabled')
        }

    }, [user, dispatch])

    return (

        <Grid
            templateColumns="1fr"
            templateRows="4rem 1fr 2rem"
            style={{
                height: "100%"
            }}
        >
            <View style={{ height: "4rem" }}>
                <AuthAppNavBar user={user}
                    searchText={searchText}
                    language={language} onSearchTextChanged={onSearchTextChanged}
                    onLanguageChanged={onLanguageChanged}
                    signOut={() => {
                        if (safeSignOut.current) {
                            safeSignOut.current()
                            safeSignOut.current = null
                            dispatch(forgetResults())
                            dispatch(forgetExercises())
                            dispatch(forgetPosts())
                            dispatch(forgetComments())
                        }
                        navigate("/")
                    }} />
            </View>
            <Authenticator className='my-2'>
                {({ signOut, user }) => {
                    safeSignOut.current = signOut
                    return (
                        <View style={{ height: 'calc(100vh - 6rem)', overflow: 'auto' }}>
                            <Outlet context={{ user, signOut, exercisesLoading }} />
                        </View>
                    )
                }
                }</Authenticator>
            <View style={{ height: "2rem" }}>
                <div className='footer d-flex justify-content-around bg-body-tertiary'>
                    <Link to="/privacy-policy" >Privacy Policy</Link>
                    <Link to="/tutorial">Tutorial</Link>
                </div>
            </View>
        </Grid>


    )

}